import React from 'react'

// pass delay: null to pause the interval (matches the react-hooks convention)
export function useInterval(callback: () => any, delay: number | null) {
  const savedCallback = React.useRef(null)
  // Remember the latest callback.
  React.useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  React.useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }

    return null
  }, [delay])
}
